import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

function ImageSlideComponent(props) {
  const { mcData, timerEnd, onValueChange } = props
  const { ControlID, Url } = mcData

  useEffect(() => {
    if (timerEnd) {
      onValueChange(ControlID, '', 0, 0, '', true)
    }
  }, [timerEnd])

  return (
    <div className='slide-comp-wrapper' style={{ height: 'fit-content' }}>
      <img
        src={Url}
        style={{
          margin: 'auto',
          zIndex: 0,
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          borderRadius: '8px'
        }}
      />
    </div>
  )

  return (
    <div
      style={{
        flex: 1,
        width: '100%',
        height: '100%',
        backgroundColor: 'lightblue',
        justifyContent: 'center',
        borderRadius: '10px',
        padding: '15px'
      }}
    >
      <div
        style={{
          flex: 1,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <img
          src={Url}
          style={{
            margin: 'auto',
            zIndex: 0,
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }}
        />
      </div>
    </div>
  )
}

ImageSlideComponent.propTypes = {
  mcData: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  timerEnd: PropTypes.bool
}

export default ImageSlideComponent
